import React from "react";
import Seo from "../components/Seo";

const H2 = ({ children }) => (
  <h2 className="text-lg md:text-xl font-bold text-slate-900 mt-10 mb-3">{children}</h2>
);
const P = ({ children }) => <p className="text-slate-600 leading-relaxed mb-3">{children}</p>;
const UL = ({ items }) => (
  <ul className="text-slate-600 leading-relaxed mb-3 list-disc pl-6 space-y-1">
    {items.map((x, i) => <li key={i}>{x}</li>)}
  </ul>
);

export default function PolitiqueConfidentialitePage() {
  return (
    <main data-testid="politique-confidentialite-page" className="bg-white">
      <Seo
        title="Politique de confidentialité | Thermasol Air Systems®"
        description="Politique de confidentialité et de gestion des cookies du site thermasol-airsystems.fr (RGPD)."
        canonical="https://thermasol-airsystems.fr/politique-confidentialite/"
      />
      <section className="pt-32 pb-20">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <h1 className="text-4xl sm:text-5xl font-extrabold text-slate-900">Politique de confidentialité</h1>
          <p className="text-slate-500 mt-3 text-sm">Dernière mise à jour : juin 2026</p>

          <H2>1. Responsable de traitement</H2>
          <P>
            <strong>France Énergie SAS</strong> (marque Thermasol Air Systems®), 13 rue des Vignes, 91330 Yerres —
            SIRET 899 346 217 00024 — est responsable du traitement des données personnelles collectées sur ce site.
            Contact : <a href="mailto:contact@thermasol-airsystems.fr" className="text-orange-600 underline">contact@thermasol-airsystems.fr</a>.
          </P>

          <H2>2. Données collectées</H2>
          <UL items={[
            "Formulaires de contact et de demande d'étude : identité, société, coordonnées (téléphone, email, adresse), informations sur votre projet (surface, activité, département).",
            "Formulaire « Devenir installateur partenaire » : société, SIRET, identité, coordonnées, zone d'intervention.",
            "Données de navigation : mesure d'audience via Google Analytics 4, uniquement après votre consentement.",
          ]} />

          <H2>3. Finalités et bases légales</H2>
          <UL items={[
            "Répondre à vos demandes et établir des études ou devis — exécution de mesures précontractuelles.",
            "Gestion de la relation commerciale et suivi des dossiers (CRM interne) — intérêt légitime.",
            "Constitution des dossiers d'aides CEE avec nos partenaires, avec votre accord — obligation contractuelle.",
            "Mesure d'audience du site — consentement (bannière cookies).",
          ]} />

          <H2>4. Destinataires</H2>
          <P>
            Vos données sont destinées aux équipes commerciales et techniques de France Énergie SAS. Elles peuvent
            être transmises à nos sous-traitants techniques (hébergement du site et de la base de données, envoi
            d'emails) et, uniquement dans le cadre d'un dossier de prime CEE, à notre partenaire délégataire
            (Eco Environnement, mandataire TotalEnergies). Elles ne sont jamais vendues à des tiers.
          </P>

          <H2>5. Durées de conservation</H2>
          <UL items={[
            "Prospects : 3 ans après le dernier contact.",
            "Clients : durée de la relation contractuelle, puis archivage selon les prescriptions légales (garanties, obligations comptables et fiscales).",
            "Consentement cookies : 12 mois.",
          ]} />

          <H2>6. Vos droits</H2>
          <P>
            Conformément au RGPD et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de
            rectification, d'effacement, d'opposition, de limitation et de portabilité de vos données. Pour les
            exercer, écrivez à{" "}
            <a href="mailto:contact@thermasol-airsystems.fr" className="text-orange-600 underline">contact@thermasol-airsystems.fr</a>{" "}
            en joignant un justificatif d'identité. Vous pouvez également introduire une réclamation auprès de la
            CNIL (<a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-orange-600 underline">www.cnil.fr</a>).
          </P>

          <H2>7. Cookies</H2>
          <P>
            Le site utilise uniquement des cookies de mesure d'audience (Google Analytics 4), déposés après votre
            consentement via la bannière dédiée. Votre choix (acceptation ou refus) est conservé 12 mois et
            modifiable à tout moment via le lien « Cookies » en bas de page. Le refus des cookies n'altère pas la
            navigation sur le site.
          </P>

          <H2>8. Sécurité</H2>
          <P>
            Les données sont hébergées dans des environnements sécurisés, l'accès aux outils internes (CRM, études)
            est protégé par authentification, et les échanges avec le site sont chiffrés (HTTPS).
          </P>
        </div>
      </section>
    </main>
  );
}
